export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: '不動産売買',
      description: '横浜市・川崎市を中心に、中古戸建・マンション・土地の売買をサポート',
      features: ['物件探しから契約まで', '資金計画のご相談', '住宅ローンサポート']
    },
    {
      icon: 'ri-tools-line',
      title: 'リフォーム・リノベーション',
      description: '空き家再生から大規模リノベーションまで、幅広く対応',
      features: ['デザイン提案', '施工管理', 'アフターサポート']
    },
    {
      icon: 'ri-building-line',
      title: '不動産管理',
      description: '賃貸物件の管理から空き家管理まで、トータルサポート',
      features: ['入居者募集', '建物メンテナンス', '家賃管理']
    },
    {
      icon: 'ri-hand-heart-line',
      title: '空き家相談',
      description: '空き家問題の解決をお手伝い。活用方法のご提案から実行まで',
      features: ['現地調査', '活用プラン提案', '売却・賃貸サポート']
    },
    {
      icon: 'ri-home-smile-line',
      title: 'マリアージュ賃貸',
      description: '譲渡型賃貸住宅で、賃貸から持ち家へのステップアップを実現',
      features: ['初期費用を抑えた入居', '家賃の一部が購入資金に', '将来の購入権利']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '不動産コンサルティング',
      description: '不動産に関するあらゆるご相談に、経験豊富なスタッフが対応',
      features: ['資産活用相談', '相続対策', '投資相談']
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">サービスのご案内</h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            購入からリフォーム、管理まで、<br />
            ワンストップでサービスを提供
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-5 md:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-teal-500 rounded-xl flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">{service.title}</h3>
              <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm md:text-base text-gray-700">
                    <i className="ri-check-line text-teal-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}